import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Searchmode, SearchType } from '../../enums/search.enum';
import { TranslateService } from '@ngx-translate/core';
import { SEARCH_ICON, CLOSE} from 'src/defaultImages.js';
@Component({
  selector: 'app-searchbox',
  templateUrl: './searchbox.component.html',
  styleUrls: ['./searchbox.component.scss'],
})
export class SearchboxComponent implements OnInit {
  images = { 
    SEARCH_ICON: SEARCH_ICON,
    CLOSE: CLOSE
  };
  @Input() placeholderText: string;
  @Input() searchMode: number = Searchmode.local;
  @Input() searchType: number = SearchType.none;
  @Input() searchKey: string;
  @Input() tableData = [];
  @Input() noSearch: boolean;
  @Output() searchData = new EventEmitter();
  subscription = new Subscription();
  searchFilter: string;
  searchInput: Subject<string> = new Subject();
  hqId = localStorage.getItem('hq_id');
  translationText;
  emitObj = { 
    data : [],
    searchInput : ''
  };

  private ngUnsubscribe = new Subject();

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    this.subscription.add(
      this.translateService.get(['CMM_MENU']).subscribe((res) => {
        this.translationText = res.CMM_MENU;
      })
    );
    this.searchInput
      .pipe(
        debounceTime(0),
        distinctUntilChanged(),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((value) => {
        if (value !== undefined && value !== null) {
          if (this.searchMode == Searchmode.local) {
            this.emitObj = {
              data: this.tableData.filter((item) =>
                item[this.searchKey].toLowerCase().includes(value.toLowerCase())
              ),
              searchInput: this.searchFilter,
            };
            this.searchData.emit(this.emitObj);
          } else if ((this.searchMode = Searchmode.server)) {
            this.searchData.emit(this.searchFilter);
          }
        }
      });
  }

  closeSearch() {
    this.searchFilter = '';
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
